import request from '@/utils/request';

const userApi = {
    getUser(){
        return request({
            url: '/app/query/user/info',
            method: 'post',
            data: {},
        })
    },
    // 修改用户信息
    updateUser({nickname,province,city,country}){
        return request({
            url: '/app/update/user/info',
            method: 'post',
            data: {
                'province': province,
                'city': city,
                'country': country,
                'nickname': nickname,
            }
        })
    },
    // 获取用户账户余额
    getUserAccount(accountType){
        return request({
            url: '/app/query/user/account',
            method: 'post',
            data: {
                'accountType': accountType, // 账户类型，0：CNY账户，1:FIL账户，2：XCH账户，3：USDT账户，4：购物基金，5：积分
            }
        });
    }
}

export default userApi;